export default __webpack_public_path__ + "static/media/windows-brands.69f0897b.svg";